import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {RoleAccess} from 'projects/core/src/lib/login/data/role-access';
import {UserRole} from 'projects/core/src/lib/login/data/user-role';
import {MiscSnackBarService} from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';
import _ from 'underscore';
import {AdminPanelService} from '../../../data/admin-panel.service';

@Component({
  selector: 'app-access-editor-dialog',
  templateUrl: './access-editor-dialog.component.html',
  styleUrls: ['./access-editor-dialog.component.scss']
})
export class AccessEditorDialogComponent implements OnInit {
  saveLoading = false;


  tempAccess: RoleAccess;

  allRoles: UserRole[];
  selectedRoles: UserRole[];

  selectedAll: boolean;

  constructor(
    protected dialogRef: MatDialogRef<AccessEditorDialogComponent>,
    protected adminPanelService: AdminPanelService,
    private miscSnackBarService: MiscSnackBarService,
    @Inject(MAT_DIALOG_DATA) private data: {
      roleAccess: RoleAccess,
      allRoles: UserRole[]
    }
  ) {
    this.allRoles = this.data.allRoles
  }

  ngOnInit(): void {
    this.tempAccess = Object.assign({}, this.data.roleAccess);
    this.selectedRoles = this.allRoles.filter(role => this.tempAccess.roles.find(accessRole => accessRole.id === role.id))
    this.countRolesMethod();
  }

  saveDict() {
    this.saveLoading = true;

    this.tempAccess.roles = this.selectedRoles

    if (this.tempAccess.id) {
      this.adminPanelService.saveRoleAccess(this.tempAccess).subscribe(newDict => {
        this.miscSnackBarService.openSuccessSnackBar('Success!')

        this.dialogRef.close(newDict);
      }, error => {
        this.miscSnackBarService.openErrorSnackBar(error.message)
        this.saveLoading = false;
      })
    } else {
      this.adminPanelService.createRoleAccess(this.tempAccess).subscribe(newDict => {
        this.miscSnackBarService.openSuccessSnackBar('Success!')

        this.dialogRef.close(newDict);
      }, error => {
        this.miscSnackBarService.openErrorSnackBar(error.message)
        this.saveLoading = false;
      })
    }
  }


  showAllButtonHeader(event: any) {
    event.stopPropagation();

    this.selectedAll = !this.selectedAll;

    if (!this.selectedAll) {
      this.selectedRoles = [];
    } else if (this.selectedAll) {
      this.selectedRoles = [...this.allRoles]
    }
    this.countRolesMethod();
  }

  showAllButton() {
    // 		if (!this.selectedAll) {
    // 			this.selectedRoles = [];
    // 		}
    // 		else if (this.selectedAll) {
    // 			this.selectedRoles = [...this.allRoles]
    // 		}
    // 		this.countRolesMethod();
  }


  countRolesMethod() {
    if (this.selectedRoles.length !== this.allRoles.length) {
      this.selectedAll = false;
    } else if (this.selectedRoles.length === this.allRoles.length) {
      this.selectedAll = true;
    }
  }

  closeDialog() {
    this.dialogRef.close('close-button');
  }

}
